module.exports = __webpack_public_path__ + "img/xls.688100e4.png";